import features from "@/configs/features";
import axios from "@/axios";

import formatError from "./formatError";
import { defineStore } from "pinia";

// Index linking API type indices to page names
const typeIndices = {
  faq: 1,
  ...(features.LEGIS ? { legislative: 2 } : {}),
};

export const usePagesStore = defineStore("pages", {
  state: () => ({
    pages: [],
  }),
  getters: {
    faq: (state) => state.pages.filter((e) => e.category === typeIndices.faq),
    legislative: (state) =>
      state.pages.filter((e) => e.category === typeIndices.legislative),
  },
  actions: {
    setPages(pages) {
      this.pages = pages;
    },
    async refresh() {
      try {
        const {
          status: pageStatus,
          data: { data: pages },
        } = await axios.get("/api/pages/?page=1&per_page=100");

        if (pageStatus === 200) {
          this.setPages(pages);
        } else {
          throw formatError(
            `Unknown status code getting pages: ${pageStatus}`,
            pageStatus
          );
        }
      } catch (e) {
        if (e.response) {
          return e.response;
        }
        throw e;
      }
      return null;
    },

    async modifyPage({ id, content, title, order }) {
      try {
        const { status } = await axios.put(`/api/pages/${id}`, {
          content,
          title,
          order,
        });
        if (status === 200) {
          this.refresh();
          return null;
          // return 0
        }
        throw formatError(`Unsupported status: ${status}`, status);
        // return 1
      } catch (e) {
        return e.response;
      }
    },

    async addPage({ typeName }) {
      const typeId = typeIndices[typeName];
      try {
        await axios.post("/api/pages", {
          type_id: typeId,
          title: "Title",
          content: "Content",
        });
        this.refresh();
      } catch (e) {
        return e.response;
      }
      return null;
    },

    async removePage({ id }) {
      try {
        await axios.delete(`/api/pages/${id}`);
        this.refresh();
      } catch (e) {
        return e.response;
      }
      return null;
    },
  },
});
// Pages are organized in the state by type id.
// Each type is a list of categories
// Each page has an id, a title and content
export default {};
